import { DateObject } from '@capsicum/common';

/**
 * Formats the given date and time value into a formatted string.
 * @param value - The date and time value to format.
 * @param includeTime - Optional. Specifies whether to include the time in the formatted string. Default is true.
 * @returns The formatted date and time string.
 * @example getFormattedDateTime('2021-06-09T06:23:00.000Z', true) // Returns '09/Jun/2023, 06:23'
 * @example getFormattedDateTime('2021-06-09T06:23:00.000Z', false) // Returns '09/Jun/2023'
 */
export const getFormattedDateTime = (value: string, includeTime = true) => {
	const date = new DateObject(value);

	// Manually format the date string
	let formattedDate = `${date.date().toString().padStart(2, '0')}/${date.format('MMM')}/${date.year()}`;

	if (includeTime) {
		formattedDate += `, ${date.hour().toString().padStart(2, '0')}:${date.minute().toString().padStart(2, '0')}`;
	}

	return formattedDate;
};
